import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  PasDateTimeComponent,
  PasInputFieldComponent,
  PasTextareaComponent,
} from '@porsche-aftersales/frontend-toolbox';
import moment from 'moment';
import { filter, map } from 'rxjs';

import { TranslatePipe } from '../../../pipes/translate.pipe';
import { dateAsObject } from '../recourse-criteria/recourse-criteria-editor.component';

import { PartsAgreementsStore } from './parts-agreements.store';

@Component({
  selector: 'app-parts-agreement-editor',
  templateUrl: './parts-agreement-editor.component.html',
  styleUrl: './parts-agreement-editor.component.scss',
  imports: [
    CommonModule,
    TranslatePipe,
    ReactiveFormsModule,
    PasInputFieldComponent,
    PasTextareaComponent,
    PasDateTimeComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartsAgreementEditorComponent {
  private readonly partsAgreementsStore = inject(PartsAgreementsStore);

  public readonly longTimeAhead = dateAsObject(new Date(9999, 11, 31));

  public readonly formGroup$ = this.partsAgreementsStore.formGroup$;

  public readonly validityDateToMinDate$ = this.formGroup$.pipe(
    filter(Boolean),
    map(formGroup => {
      const today = new Date();
      const validityDateFrom = new Date(formGroup.get('validityDateFrom')?.value);
      const earliestAllowedEndDate = today > validityDateFrom ? today : validityDateFrom;
      const dayAfter = moment(earliestAllowedEndDate).add(1, 'days').toDate();
      return dateAsObject(dayAfter);
    }),
  );
}
